import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { View } from 'react-native';
import { DETAILS_SCREENS_CONTAINER_STYLES, SCREEN_PADDING_HORIZONTAL } from '@v2/pages/common/constants/base.constants';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { productionBatchStatistics } from '@reducers/statistics';
import { getNCFileById } from '@reducers/manufacture';
import { close as clearTools, getTools } from '@reducers/clampingTools';
import { connect } from 'react-redux';
import { useBatchDetails } from '@v2/pages/common/hooks/useBatchDetails';
import { updateHeaderConfig } from '@reducers/details';
import BatchTimeline from './components/BatchTimeline/BatchTimeline';
import { isWeb } from '@helpers';
import { fullWidth, width } from '@components/frame';

interface BatchDetailsBatchProps {}

const BatchDetailsBatchTimelineComponent: FC<BatchDetailsBatchProps> = ({
  productionBatchStatistics,
  getNCFileById,
  getTools,
  clearTools,
  updateHeaderConfig,
}) => {
  const title = useTitle();

  const { batchId } = useBatchDetails({
    clearTools,
    getNCFileById,
    getTools,
    productionBatchStatistics,
    updateHeaderConfig,
  });

  return (
    <DetailsPageWrapper title={title.batch}>
      <View
        style={{
          ...DETAILS_SCREENS_CONTAINER_STYLES,
          marginInline: 'auto',
          width: '100%',
        }}
      >
        <BatchTimeline productionBatchId={batchId} width={isWeb ? fullWidth : width} withoutList horizontalOffset={SCREEN_PADDING_HORIZONTAL * 2} />
      </View>
    </DetailsPageWrapper>
  );
};

const BatchDetailsBatchTimeline = connect(null, {
  getNCFileById,
  productionBatchStatistics,
  getTools,
  clearTools,
  updateHeaderConfig,
})(BatchDetailsBatchTimelineComponent);

export { BatchDetailsBatchTimeline };
